import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { ServicesStatus } from '../config/firebase';

export function useServicesStatus() {
  const [status, setStatus] = useState<ServicesStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'settings', 'servicesStatus'), (doc) => {
      if (doc.exists()) {
        setStatus(doc.data() as ServicesStatus);
      }
      setLoading(false);
    }, (error) => {
      console.error('Erreur lors de la récupération du statut des services:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { status, loading };
} 